module.exports = __webpack_public_path__ + "img/task-board-finance.79f92c96.png";